import React, { useState } from 'react';
import {
    FaBrain, FaCrosshairs, FaRocket, FaChartLine, FaUsers, FaCrown, FaEdit, FaHistory
} from 'react-icons/fa';
import { useMarketingObjectives } from '../../hooks/useMarketingObjectives';
import ChangeObjectiveModal from '../modals/ChangeObjectiveModal';
import ObjectiveHistoryModal from '../modals/ObjectiveHistoryModal';

const PriorityObjectiveCard = ({ userId, onActionClick }) => {
    const [showChangeModal, setShowChangeModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const {
        activeObjective,
        loading,
        error,
        changeActiveObjective
    } = useMarketingObjectives(userId);



    const getIcon = (objectiveType) => {
        switch (objectiveType) {
            case 'INCREASE_SALES':
                return <FaChartLine className="text-green-500" />;
            case 'ACQUIRE_NEW_CUSTOMERS':
                return <FaUsers className="text-blue-500" />;
            case 'RETAIN_EXISTING_CUSTOMERS':
                return <FaCrown className="text-purple-500" />;
            default:
                return <FaBrain className="text-blue-500" />;
        }
    };

    const getColor = (objectiveType) => {
        switch (objectiveType) {
            case 'INCREASE_SALES':
                return 'bg-gradient-to-r from-green-500 to-teal-600';
            case 'ACQUIRE_NEW_CUSTOMERS':
                return 'bg-gradient-to-r from-blue-500 to-indigo-600';
            case 'RETAIN_EXISTING_CUSTOMERS':
                return 'bg-gradient-to-r from-purple-500 to-pink-600';
            default:
                return 'bg-gradient-to-r from-blue-500 to-indigo-600';
        }
    };

    const getActionText = (objectiveType) => {
        switch (objectiveType) {
            case 'INCREASE_SALES':
                return 'Crear campaña de ventas IA';
            case 'ACQUIRE_NEW_CUSTOMERS':
                return 'Crear campaña de captación IA';
            case 'RETAIN_EXISTING_CUSTOMERS':
                return 'Crear campaña de fidelización IA';
            default:
                return 'Crear primera campaña IA';
        }
    };

    const handleChangeObjective = async (objectiveData) => {
        try {
            await changeActiveObjective(objectiveData);
            setShowChangeModal(false);
        } catch (error) {
            console.error('Error al cambiar objetivo:', error);
        }
    };

    // Mostrar loading
    if (loading) {
        return (
            <div className="objective-card bg-gradient-to-r from-gray-500 to-gray-600 text-white">
                <div className="flex items-center justify-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                    <span className="ml-3 text-lg">Cargando objetivo...</span>
                </div>
            </div>
        );
    }

    // Si no hay objetivo activo o hay error, mostrar objetivo por defecto
    if (!activeObjective || error) {
        return (
            <>
                <div className="objective-card bg-gradient-to-r from-blue-500 to-indigo-600 text-white">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <div className="text-3xl mr-6">
                                <FaBrain className="text-blue-500" />
                            </div>
                            <div>
                                <div className="flex items-center mb-3">
                                    <h2 className="text-2xl font-bold">
                                        Objetivo Principal:
                                    </h2>
                                    <span className="text-2xl font-bold text-white ml-2">
                                        ¡Escoge tu primer objetivo!
                                    </span>
                                    <div className="flex items-center ml-3 space-x-2">
                                        <button
                                            onClick={() => setShowHistoryModal(true)}
                                            className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors"
                                            title="Ver historial de objetivos"
                                        >
                                            <FaHistory className="text-sm" />
                                        </button>
                                        <button
                                            onClick={() => setShowChangeModal(true)}
                                            className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors"
                                            title="Establecer objetivo"
                                        >
                                            <FaEdit className="text-sm" />
                                        </button>
                                    </div>
                                </div>
                                <p className="text-white/80 text-lg leading-relaxed">
                                    Para empezar a sacar el máximo partido a PetitPrime
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <ChangeObjectiveModal
                    isOpen={showChangeModal}
                    onClose={() => setShowChangeModal(false)}
                    onObjectiveChange={handleChangeObjective}
                    currentObjective={activeObjective}
                />

                <ObjectiveHistoryModal
                    isOpen={showHistoryModal}
                    onClose={() => setShowHistoryModal(false)}
                    userId={userId}
                />
            </>
        );
    }

    return (
        <>
            <div className={`objective-card ${getColor(activeObjective.objectiveType)} text-white`}>
                <div className="flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="text-3xl mr-6">
                            {getIcon(activeObjective.objectiveType)}
                        </div>
                        <div>
                            <div className="flex items-center mb-3">
                                <h2 className="text-2xl font-bold">
                                    Objetivo Principal:
                                </h2>
                                <span className="text-2xl font-bold text-white ml-2">
                                    {activeObjective.objectiveName}
                                </span>
                                <div className="flex items-center ml-3 space-x-2">
                                    <button
                                        onClick={() => setShowHistoryModal(true)}
                                        className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors"
                                        title="Ver historial de objetivos"
                                    >
                                        <FaHistory className="text-sm" />
                                    </button>
                                    <button
                                        onClick={() => setShowChangeModal(true)}
                                        className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors"
                                        title="Escoger nuevo objetivo"
                                    >
                                        <FaEdit className="text-sm" />
                                    </button>
                                </div>
                            </div>
                            <p className="text-white/80 text-lg leading-relaxed">
                                {activeObjective.objectiveDescription}
                            </p>
                            {activeObjective.startDate && (
                                <p className="text-white/70 text-xs mt-2">
                                    Establecido el {new Date(activeObjective.startDate).toLocaleDateString('es-ES')}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ChangeObjectiveModal
                isOpen={showChangeModal}
                onClose={() => setShowChangeModal(false)}
                onObjectiveChange={handleChangeObjective}
                currentObjective={activeObjective}
            />

            <ObjectiveHistoryModal
                isOpen={showHistoryModal}
                onClose={() => setShowHistoryModal(false)}
                userId={userId}
            />
        </>
    );
};

export default PriorityObjectiveCard; 